module.exports = __webpack_public_path__ + "img/info.c7c7bce7.png";